export const YOUR_GOOGLE_MAPS_API_KEY =
  "AIzaSyB6hBxsLEjS9vUuFdrtpAO4OaeumU9ytwQ";

export const videos = [
  {
    title:
      "مرض السكر - هل الأنسولين لازم كعلاج؟ و هل يمكن الاستغناء عنه بالأدوية",
    subtitle: `
    ما هي تحاليل السكر المختلفة و مدلولاتها
علاج السكر بشكل عام و أنواعه
ما هي مقاومة الأنسولين  و أهميتها
ما هي أعراض ارتفاع و انخفاض السكر و أيها أهم 
كيفية التعامل في حالات الطوارئ
    `,
    url: "https://youtu.be/kA-FMjPxcNY",
    order: 1,
  },
  {
    title: "الروتين الصباحي لمرضى السكر و حكاية سكر الدايت",
    subtitle: `أهم الأشياء التي يجب أن يقوم بها مريض السكر يوميا
هل المحليات الصناعية تسبب السرطان
تأثير الرياضة على السكر`,
    url: "hhttps://youtu.be/wVZnyYrEVXw",
    order: 2,
  },
  {
    title: "title2",
    subtitle: "subtitle2 information",
    url: "https://www.youtube.com/embed/gJJDkVFQf8s?si=U9VMLmFDs9rNXwfb",
    order: 3,
  },
];

export const districts = [
  "Madinaty",
  "FifthInstallment",
  "Elshorouk",
  "MostakbalCity",
  "ElObour",
];
